import { ACTION_TYPES } from "../../../constants";

const initialState = {
  requesting: false,
  success: false,
  error: false,
  data: null,
};

const getDoctorExpertiseReducer = (state = initialState, action = {}) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.CLINIC.DOCTOR_EXPERTISE.SUCCESS: {
      return {
        success: true,
        requesting: false,
        error: false,
        data: payload,
      }
    }
    case ACTION_TYPES.CLINIC.DOCTOR_EXPERTISE.REQUESTING:
      return { success: false, requesting: true, error: false };
    case ACTION_TYPES.CLINIC.DOCTOR_EXPERTISE.ERROR:
      return { success: false, requesting: false, error: true, data: payload };
    case ACTION_TYPES.CLINIC.DOCTOR_EXPERTISE.RESET:
      return initialState;
    default:
      return state
  }
}

export default getDoctorExpertiseReducer